import Colors from "../../../../../theme/colors";

const style = {
  container: {
    color: Colors.white,
  },
  tableHeadCell: {
    fontSize: "14px",
    background: "#BAD9EC",
    border: "none",
    color: "#000000",
    fontWeight: 700,
    padding: "18px 10px",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    textAlign: "center",
  },
  tableBody: {
    backgroundColor: Colors.white,
    border: "none",
    color: Colors.white,
  },
  emptyList: {
    display: "flex",
    justifyContent: "center",
    padding: "1rem",
    width: "100%",
  },
};

export default style;
